import { container } from "assets/jss/westmorland-lodge-44.jsx";

// import image from "assets/img/bg/login-bg.jpg";

const loginModalStyle = {
  section: {
    minHeight: "20vh",
    maxHeight: "400px",
    overflow: "hidden",
    padding: "0",
    backgroundPosition: "top center",
    backgroundSize: "cover",
    margin: "0",
    border: "0",
    display: "flex",
    alignItems: "center"
  },
  container,
  form: {
    margin: "0"
  },
  cardHeader: {
    width: "auto",
    textAlign: "center",
    marginLeft: "20px",
    marginRight: "20px",
    marginTop: "-40px",
    padding: "20px 0",
    marginBottom: "15px"
  },
  divider: {
    marginTop: "10px",
    marginBottom: "0px",
    textAlign: "center"
  },
  button: {
    paddingTop: "0rem",
    border: "0",
    borderRadius: "6px",
    justifyContent: "center !important"
  },
  inputIconsColor: {
    color: "#495057"
  },
  popover: {
    rounded: "false"
  },
  paper: {
    backgroundColor: "rgba(159, 168, 183, 0.8)"
//    backgroundColor: "rgba(0, 0, 0, 0)"
  }
};

export default loginModalStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/westmorland-lodge-44/components/loginModalStyle.jsx